module.exports = __webpack_public_path__ + "img/bleu_adm_1390.bd6a0def.jpg";